"use client";

import Image from "next/image";
import Link from "next/link";
import { useState } from "react";
import { motion } from "motion/react";
import { STANDS } from "@/lib/data";

export function Solutions() {
  const [active, setActive] = useState(2);

  return (
    <section className="border-y border-line px-5 py-20 md:px-8 md:py-28">
      <div className="mx-auto mb-10 flex max-w-7xl items-end justify-between">
        <h2 className="font-display text-4xl md:text-6xl">Quatre distances.</h2>
        <Link href="/stands" className="hidden text-xs tracking-[0.18em] text-brass uppercase md:block">
          Fiche stands
        </Link>
      </div>

      <div className="mx-auto flex max-w-7xl flex-col overflow-hidden md:h-[72vh] md:flex-row">
        {STANDS.map((item, i) => {
          const open = active === i;
          return (
            <motion.button
              key={item.slug}
              type="button"
              onMouseEnter={() => setActive(i)}
              onFocus={() => setActive(i)}
              onClick={() => setActive(i)}
              className="relative min-h-[38vh] overflow-hidden text-left md:h-full"
              animate={{ flexGrow: open ? 2.1 : 1 }}
              transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            >
              <Image src={item.image} alt={`Stand ${item.dist}`} fill className="object-cover" sizes="50vw" />
              <div className={`absolute inset-0 transition ${open ? "bg-ink/30" : "bg-ink/65"}`} />
              <div className="absolute inset-0 flex flex-col justify-end p-6 md:p-8">
                <span className="font-mono text-brass">{item.tag}</span>
                <h3 className="font-display mt-1 text-5xl md:text-7xl">{item.dist}</h3>
                <motion.p
                  className="mt-3 max-w-sm text-sm text-paper/85"
                  animate={{ opacity: open ? 1 : 0, y: open ? 0 : 10 }}
                >
                  {item.lead}
                </motion.p>
              </div>
            </motion.button>
          );
        })}
      </div>
    </section>
  );
}
